<div class="role-form page">
  @if (!isLoading) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="heading-wrapper">
      <h4>{{ 'pages.role.titleEdit' | translate }} - {{ role.name }}</h4>
      <div class="actions d-flex">
        @if (isEditable){
          <button class="primary add-btn" (click)="submit()">
            {{ 'pages.role.editRole' | translate }}
          </button>
          <button class="secondary back-btn" (click)="back()">
            {{('pages.role.cancel' | translate) }}
          </button>
        } @else {
          <button class="secondary back-btn" (click)="back()">
            {{ ('pages.role.back' | translate) }}
          </button>
        }
      </div>
    </div>
    <div class="policy-wrapper">
      @for (policy of role.policies; track policy.code) {
      <app-edit-policy [policy]="policy" [disabled]="!isEditable"
        (policyChange)="handlePolicyChange($event, policy.code)" />
      }
    </div>
  } @else {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="isLoading" />
    </div>
  }
</div>
